import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  useToast
} from '@chakra-ui/react';
import Form from '@rjsf/chakra-ui';
import validator from "@rjsf/validator-ajv8";
import { getDeletedValues } from '../../../util/helper';
import { getEventMasterlistIntroductionData, updateEventMasterlistData } from '../../../services/EventMasterlist';
import { RjsfSubmitButton } from '../../../RJSFCommonSchemas';
import FormLoader from '../../../CommonComponents/FormLoader';
import { showErrorToast, showSuccessToast } from "../../../util/errorHandler";


const Team = () => {
  const { alias } = useParams();
  const [basicFieldData, setBasicFieldData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [quickSave, setQuickSave] = useState(false);
  const toast = useToast();


  const schema = {
    "title": "",
    "description": "",
    "type": "object",
    "properties": {
      "curator": {
        "type": "array",
        "title": "Curator",
        "items": {
          "type": "object",
          "properties": {
            "alias": {
              "type": "string",
              "title": "Alias"
            },
          }
        }
      },
      "organiser": {
        "type": "array",
        "title": "Organiser",
        "items": {
          "type": "object",
          "properties": {
            "alias": {
              "type": "string",
              "title": "Alias"
            },
          }
        }
      },
    }
  }

  const uiSchema = {
    ...RjsfSubmitButton(isSubmitting),
    curator: { "ui:emptyValue": "" },
    organiser: { "ui:emptyValue": "" }
  };

  const formData = basicFieldData;

  // Fetch initial data
  useEffect(() => {
    const getTeamData = async () => {
      try {
        if (alias) {
          const result = await getEventMasterlistIntroductionData(alias, 'team');
          if (result) {
            setBasicFieldData(result?.[0]);
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
                showErrorToast(toast, "Failed to fetch data");
      } finally {
        setIsLoading(false);
      }
    };

    getTeamData();
  }, [alias, toast, quickSave]);

  // Submit updated data
  const handleSubmit = async (formData) => {

    const deletedValues = getDeletedValues(basicFieldData, formData);

    try {
      if (alias) {
        setIsSubmitting(true);
        const result = await updateEventMasterlistData(alias, formData, deletedValues);

        if (result?.success) {
          setQuickSave(prev => !prev);

                    showSuccessToast(toast, "Data updated successfully");
        }
      }
    } catch (error) {
      console.error('Error updating film data:', error);
            showErrorToast(toast, "Failed to update film data");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box maxW="auto">
      {isLoading ? (
        <FormLoader />
      ) : (

    <Form schema={schema} uiSchema={uiSchema} formData={formData} validator={validator} onSubmit={(e) => handleSubmit(e.formData)}>
    </Form>
      )}
    </Box>

  );
};

export default Team;